import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Observable } from 'rxjs';
import { TimeDisplay, TimeDisplayService } from 'shared/time-display-service/time-display.service';

@Component({
    selector: 'ce-time-display-menu',
    templateUrl: './time-display-menu.component.html',
    styleUrls: ['./time-display-menu.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TimeDisplayMenuComponent {
    timeObservables$: Observable<TimeDisplay[]> = this.timeDisplayService.timeObservables$;
    timeObservable$: Observable<TimeDisplay> = this.timeDisplayService.timeObservable$;

    constructor(private timeDisplayService: TimeDisplayService) {}

    selectOption(selectedTime: TimeDisplay): void {
        this.timeDisplayService.selectTime(selectedTime);
    }
}
